'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _client = require('../../utils/client');

var _me = require('../../api/me');

var _crossDomain = require('../../utils/cross-domain');

var _button = require('constructicon/button');

var _button2 = _interopRequireDefault(_button);

var _loading = require('constructicon/loading');

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SingleSignOnLink = function (_Component) {
  _inherits(SingleSignOnLink, _Component);

  function SingleSignOnLink(props) {
    _classCallCheck(this, SingleSignOnLink);

    var _this = _possibleConstructorReturn(this, (SingleSignOnLink.__proto__ || Object.getPrototypeOf(SingleSignOnLink)).call(this, props));

    _this.submitForm = _this.submitForm.bind(_this);

    _this.state = {
      loading: false,
      target: props.target
    };
    return _this;
  }

  _createClass(SingleSignOnLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _window = window,
          navigator = _window.navigator;

      var ua = navigator.userAgent || navigator.vendor || window.opera;

      // Detect FB mobile browser
      if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1) {
        this.setState({ target: '_self' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          loadingProps = _props.loadingProps,
          method = _props.method,
          token = _props.token,
          url = _props.url,
          props = _objectWithoutProperties(_props, ['label', 'loadingProps', 'method', 'token', 'url']);

      var _state = this.state,
          loading = _state.loading,
          target = _state.target;

      var safeProps = (0, _omit2.default)(props, ['authType']);

      return _react2.default.createElement(
        'div',
        { ref: 'root' },
        token && !(0, _client.isJustGiving)() ? _react2.default.createElement(
          'form',
          {
            action: (0, _client.getBaseURL)() + '/api/v2/authentication/sessions',
            method: method,
            target: target,
            onSubmit: function onSubmit(e) {
              return _this2.setState({ loading: true });
            }
          },
          _react2.default.createElement('input', { type: 'hidden', name: 'access_token', value: token }),
          _react2.default.createElement('input', { type: 'hidden', name: 'return_to', value: url }),
          _react2.default.createElement(
            _button2.default,
            _extends({}, safeProps, { type: 'submit' }),
            _react2.default.createElement(
              'span',
              null,
              label
            ),
            loading && _react2.default.createElement(_loading2.default, loadingProps)
          )
        ) : _react2.default.createElement(
          _button2.default,
          _extends({
            tag: 'a',
            href: url,
            target: target,
            onClick: token && (0, _client.isJustGiving)() && this.submitForm
          }, safeProps),
          _react2.default.createElement(
            'span',
            null,
            label
          ),
          loading && _react2.default.createElement(_loading2.default, loadingProps)
        )
      );
    }
  }, {
    key: 'submitForm',
    value: function submitForm(event) {
      var _props2 = this.props,
          authType = _props2.authType,
          token = _props2.token,
          url = _props2.url,
          method = _props2.method;
      var root = this.refs.root;
      var target = this.state.target;

      var decoded = window.atob(token).split(':');

      event.preventDefault();
      this.setState({ loading: true });

      window.addEventListener('message', function (_ref) {
        var data = _ref.data;

        if (data === 'cross-domain-cookie-auth') {
          return (0, _me.fetchCurrentUser)({ authType: authType, token: token }).then(function () {
            var formSubmission = setInterval(function () {
              try {
                return root.querySelector('iframe').contentWindow.location.origin;
              } catch (e) {
                clearInterval(formSubmission);
                return target === '_blank' ? window.open(url, '_blank') : window.location.assign(url);
              }
            }, 100);
          }).catch(function (error) {
            return Promise.reject(error);
          });
        }
      });

      return (0, _crossDomain.submitCrossDomainForm)({
        parent: root,
        method: method,
        message: 'cross-domain-cookie-auth',
        action: (0, _client.getBaseURL)().replace('api', 'www') + '/signin/login',
        inputs: [{ name: 'Email', value: decoded[0] }, { name: 'Password', value: decoded[1] }, { name: 'LoginForever', value: true }]
      });
    }
  }]);

  return SingleSignOnLink;
}(_react.Component);

SingleSignOnLink.propTypes = {
  /**
   * The token for an authenticated user
   */
  token: _propTypes2.default.string,

  /**
   * The URL of a page
   */
  url: _propTypes2.default.string.isRequired,

  /**
   * Button label
   */
  label: _propTypes2.default.any,

  /**
   * The target for the form or anchor
   */
  target: _propTypes2.default.oneOf(['_self', '_blank', '_parent', '_top']),

  /**
   * The method for the form action
   */
  method: _propTypes2.default.string,

  /**
   * Props to be forwarded to the Loading dots
   */
  loadingProps: _propTypes2.default.object
};

SingleSignOnLink.defaultProps = {
  authType: 'Basic',
  label: 'My Fundraising Page',
  target: '_top',
  method: 'POST'
};

exports.default = SingleSignOnLink;


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/single-sign-on-link/index.js
// module id = 501
// module chunks = 0